import React, { Component } from "react";
import { Form as FormUi, Segment } from "semantic-ui-react";
import Axios from 'axios';
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import { translate } from "react-i18next";
import InsertBillingParty from "../../../components/billingPartyComponent/insertBillingParty";
import ReadVAxios from "../../../components/axiosComponent/readV";
import { isEmpty } from 'lodash';
import RatechartTable from "./chartTable";
import BranchTable from "./branchTable";
import AddUserTable from "./addUserTable";
import BillingPartyVehicles from "./billingPartyVehicles";
import { LOCAL_STORAGE } from "../../../utils/constant";
import ReadAxios from "../../../components/axiosComponent/read";
import { aesDecrypt } from "../../../utils/commonFunctionalities";



// const InsertVendor = ({ values, touched, errors, t, editData, usersList, action }) => {

class AddBranches extends Component {

  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      branchData: [],
      editData: {},
      rowData: [],
      users: [],
      loadingData: true,
      billingPartyVehicles : []
      // editData:props.editData
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: this.props.location.state,
      }, () => {
        if (this.props.location.state.billingPartyId) {

          let token = LOCAL_STORAGE.userToken
          let userId = LOCAL_STORAGE.userId
          let customerNo = LOCAL_STORAGE.customerNo

          Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${this.props.location.state.billingPartyId}`, {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization': token
            }
          })
            .then(async(dataArray) => {
              if(dataArray?.data?.resultSet?.length){
                for(let data of dataArray.data.resultSet){
                  if(data.billingPartyBranchGst) data.billingPartyBranchGst = await aesDecrypt(data.billingPartyBranchGst);
                  if(data.billingPartyBranchPan) data.billingPartyBranchPan = await aesDecrypt(data.billingPartyBranchPan);
                  if(data.billingPartyBranchAccountNumber) data.billingPartyBranchAccountNumber = await aesDecrypt(data.billingPartyBranchAccountNumber);
                  if(data.billingPartyBranchBankIFSC) data.billingPartyBranchBankIFSC = await aesDecrypt(data.billingPartyBranchBankIFSC);
                }
                this.setState({ loadingData: false, branchData: dataArray.data.resultSet });
              }else{
                this.setState({ loadingData: false, branchData: [] });
              }
            })
            .catch((err) => {

            })

          Axios.post(`${process.env.REACT_APP_MASTER_API}/users/billing_party`, {
            customerNumber: customerNo,
            userId: userId,
            billingPartyId: this.props.location.state.billingPartyId
          },
          { headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token
            }
          })
            .then((dataArray) => {
              console.log({usersss: dataArray.data.resultSet})
              isEmpty(dataArray)
                ? this.setState({ loadingData: false, users: [] })
                : this.setState({ loadingData: false, users: dataArray?.data?.resultSet });
            })
            .catch((err) => {

            })

            this.getBillingPartyVehicles(this.props.location.state.billingPartyId);

        }
      });
    }
  }

  getBillingPartyVehicles = (billing_party_id)=>{
    ReadAxios({
      url : `billingPartyVehicleMapping/${billing_party_id}`
    }).then((result)=>{
     if(result?.data?.resultSet?.length){
      this.setState({ billingPartyVehicles: result?.data?.resultSet });
     }
    }).catch((err)=>{
      console.log(err);
    })
  }

  onFormSubmit = () => {
    this.props.history.push("/billingParty");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.state.title === 'add_title' ? 'Add' : 'Edit'} LinkName="/billingParty" />
        <div className="m-2">
          <InsertBillingParty
            title={this.state.title == 'edit_title' ? 'edit' : 'create'}
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
        <div className="m-2">
          {this.state.title == 'edit_title' ?
            <>

              <BranchTable
                editData={this.state.editData}
                billingPartyID={this.props.location.state.billingPartyId}
                vendor_code={this.state.editData.transporterCode}
                BranchList={this.state.branchData}
                fileName="billingPartyBranchMaster"
                importBaseUrl="billingPartyBranchMaster"
                masterIdName="billingPartyId"
                masterIdValue={this.props.location.state.billingPartyId}
              />
              <AddUserTable 
                mainId={this.state.editData?.billingPartyId} 
                modalType="billing_party" 
                usersItems={this.state.users} 
                isBusinessUnit={true}
              />
              <BillingPartyVehicles
              mappingData = {this.state.billingPartyVehicles}
              billingPartyId={this.props.location.state.billingPartyId}
              />


              {/* <>
              <RatechartTable
              vendorId={this.state.editData.transporterMasterId}
              vendor_code={this.state.editData.transporterCode}
              />
            </>
            <AddUserTable
              mainId={this.state.editData.transporterMasterId} 
              modalType="vendor"
            usersItems={this.state.editData.users} 
            /> */}
            </>
            :
            <>
              <Segment style={{ position: "inherit" }}>
                <div >
                  <h6>Note - Branch, User and Rate Chart can be added while editing Billing</h6>
                </div>
              </Segment>
            </>}
        </div>
      </React.Fragment>
    );
  }
}

export default translate("create_billing_party")(AddBranches);
